/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './queryLabels.defs'
export { main as default } from './queryLabels.defs'
